import React, { Component } from 'react';
import { CSVLink } from "react-csv";
import { Button } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import { Container } from "react-bootstrap";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { apiDelete, apiGet, apiPost, apiPut } from "./api/server"
 

 
class AsyncCSV extends Component {
  
  constructor(props) {
    const today = new Date()
    const weekago = new Date()
    weekago.setDate(today.getDate() - 6)
    super(props);
    this.state = {
      data: [],
      filename: "",
      headers: [],
      from: weekago,
      to: today
    }
    this.csvLinkEl = React.createRef();
  }
 
  getExpertReportData = () => {
    return apiGet(`intranetreports/getexpertsearchlog`)
      .then(res => res.json());
  }
 
  downloadExpertReport = async () => {
    
    const data = await this.getExpertReportData();
    this.setState({
       data: data.results,
       filename: "expert_search_log.csv",
       headers:  [
        { label: "ID", key: "id" },
        { label: "Date", key: "date" },
        { label: "Website", key: "site" },
        { label: "Service", key: "service" },
        { label: "Subservice", key: "subservice" },
        { label: "Free Text", key: "freetext" },
        { label: "Postcode", key: "postcode" },
        { label: "MeetType", key: "meettype" },
        { label: "DriveTime", key: "drivetime" },
        { label: "BusType", key: "bustype" },
        { label: "No Results Found", key: "noresults" },
        { label: "Profile Viewed", key: "profileview" },
        { label: "Form Clicked", key: "formclick" },
        { label: "Form Filled", key: "formfilled" },
        { label: "Diary Clicked", key: "diaryclick" },
        { label: "Diary Booked", key: "diarybooked" },
        { label: "LinkedIn Clicked", key: "linkedinclick" },
        { label: "Website Clicked", key: "websiteclick" },
        { label: "A B Test", key: "ab" }
      ]
    }, () => {
      setTimeout(() => {
        this.csvLinkEl.current.link.click();
      });
    });
  }

  searchLogDateReport = () => {
    const from = this.state.from
    const formattedfrom = `${from.getYear() + 1900}-${from.getMonth() + 1}-${from.getDate()}`
    const to = new Date()
    to.setDate(this.state.to.getDate() + 1)
    const formattedto = `${to.getYear() + 1900}-${to.getMonth() + 1}-${to.getDate()}`
    apiGet(`intranetreports/getexpertsearchlogdaterange?from=${formattedfrom}&to=${formattedto}`)
      .then(res => {
        res.json().then(json => {
          let formatteddata = {}
          json.results.forEach(row => {
            if(formatteddata[row.service]){
              if(row.subservice){
                if(formatteddata[row.service].subs[row.subservice]){
                  //Add to count and add postcode to subservice
                  formatteddata[row.service].subs[row.subservice].count++
                  if(row.meettype && row.meettype.startsWith("Face")){
                    formatteddata[row.service].subs[row.subservice].f2f++
                    formatteddata[row.service].subs[row.subservice].postcodes.push(row.postcode)
                  }
                }else{
                  //Create the subservice
                  formatteddata[row.service].subs[row.subservice] = {
                    count: 1,
                    f2f: 0,
                    postcodes: [],
                  }
                  if(row.meettype && row.meettype.startsWith("Face")){
                    formatteddata[row.service].subs[row.subservice].f2f++
                    formatteddata[row.service].subs[row.subservice].postcodes.push(row.postcode)
                  }
                }
              }else{
                //Add to count and add postcode to service
                formatteddata[row.service].count++
                if(row.meettype && row.meettype.startsWith("Face")){
                  formatteddata[row.service].f2f++
                  formatteddata[row.service].postcodes.push(row.postcode)
                }
              }
            }else{
              if(row.subservice){
                //Create the service and subservice
                formatteddata[row.service] = {
                  count: 0,
                  f2f: 0,
                  postcodes: [],
                  subs: {}
                }
                formatteddata[row.service].subs[row.subservice] = {
                  count: 1,
                  f2f: 0,
                  postcodes: [],
                }
                if(row.meettype && row.meettype.startsWith("Face")){
                  formatteddata[row.service].subs[row.subservice].f2f++
                  formatteddata[row.service].subs[row.subservice].postcodes.push(row.postcode)
                }

              }else{
                //Create the service
                formatteddata[row.service] = {
                  count: 1,
                  f2f: 0,
                  postcodes: [],
                  subs: {}
                }
                if(row.meettype && row.meettype.startsWith("Face")){
                  formatteddata[row.service].f2f++
                  formatteddata[row.service].postcodes.push(row.postcode)
                }
              }
            }
          })
          const finaliseddata = [];
          for (const [serv, value] of Object.entries(formatteddata)) {
            if(serv !== "null"){
              const uniqueSet = new Set(value.postcodes);
              const postcodes = [...uniqueSet];
              const service = {
                service: serv,
                subservice: "none",
                count: value.count,
                f2f: value.f2f,
                postcodes: postcodes
              }
              finaliseddata.push(service)
              if(value.subs){
                for (const [subserv, subsvalue] of Object.entries(value.subs)) {
                  const uniqueSet = new Set(subsvalue.postcodes);
                  const subpostcodes = [...uniqueSet];
                  const sub = {
                    service: serv,
                    subservice: subserv,
                    count: subsvalue.count,
                    f2f: subsvalue.f2f,
                    postcodes: subpostcodes
                  }
                  finaliseddata.push(sub)
                }
              
              }
            }
          }
          this.setState({
            data: finaliseddata,
            headers :[
              { label: "Service", key: "service" },
              { label: "Subservice", key: "subservice" },
              { label: "Count", key: "count" },
              { label: "F2f Count", key: "f2f" },
              { label: "Postcodes", key: "postcodes" },
            ],
            filename: "search-log-by-date-Range.csv" 
          }, () => {
            setTimeout(() => {
              this.csvLinkEl.current.link.click();
            });
          })
        })
      });
  }
 
  render() {
    const { data, headers, filename, from, to } = this.state;
 
    return (
      <Container>
      <div className="section">
        <Row style={{paddingBottom:"10px"}}>
          <Col md={3}>Expert Search Log Report</Col>
          <Col md={3}><Button onClick={this.downloadExpertReport}>Download</Button></Col>   
        </Row>
        <Row style={{paddingBottom:"10px"}}>
          <Col md={3}>Expert Search Log By Date Report</Col>
          <Col md={3}><Button onClick={this.searchLogDateReport}>Download</Button></Col> 
          <Col md={3}>
            <DatePicker selected={from} onChange={(date) => this.setState({from: date})} />
          </Col>
          <Col md={3}>
            <DatePicker selected={to} onChange={(date) => this.setState({to: date})} />
          </Col>
           
        </Row>
        <Row style={{paddingBottom:"10px"}}>
          <Col md={3}>Expert Services Report</Col>
          <Col md={3}><a href="expertcat"><Button>View</Button></a></Col>   
        </Row>
 
        <CSVLink
          headers={headers}
          filename={filename}
          data={data}
          ref={this.csvLinkEl}
        />
      </div>
      </Container>
    );
  }
}
 
export default AsyncCSV;